<template>
	<el-tabs type="border-card">
		<el-tab-pane label="淘宝导入">
			<el-form ref="form">
				<el-form-item label="导入来源" label-width="180px">
					<el-select v-model="value" placeholder="请选择" style="width:100%">
						<el-option label="淘宝" value="value1"></el-option>
						<el-option label="天猫" value="value2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="ID" label-width="180px">
					<el-input placeholder="请输入ID"/>
				</el-form-item>
				<el-button type="danger" style="margin-left: 180px;">提交</el-button>
			</el-form>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	export default {
		data() {
			return {
				value:""
			}
		},
		methods: {}
	}
</script>

<style>
</style>
